import { Component, Input } from '@angular/core';
import SlotFirstPageModel from '../../models/slot-first-page.model';
import { SlotAddonsService } from '../order-addons/slot-addons.service';
import DataSlot from '../../models/data-slot-first-page.model';

@Component({
  selector: 'new-offer-slot-add-addons',
  templateUrl: './new-offer-slot-add-addons.component.html',
})
export class NewOfferSlotAddAddonsComponent {
  @Input() slot: SlotFirstPageModel | DataSlot;

  constructor(private slotAddonsService: SlotAddonsService) {}

  public showAddons($event: MouseEvent): void {
    $event.preventDefault();

    this.slotAddonsService.showModal(this.slot);
  }
}

